export * from "./favorite-card.component";
